import { render, staticRenderFns } from "./recoScripts.vue?vue&type=template&id=8dd7bb00&scoped=true&"
import script from "./recoScripts.vue?vue&type=script&lang=js&"
export * from "./recoScripts.vue?vue&type=script&lang=js&"
import style0 from "./recoScripts.vue?vue&type=style&index=0&id=8dd7bb00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd7bb00",
  null
  
)

export default component.exports